import { Outlet } from "react-router-dom";

const LearningProgramLayout = () => {
  return <Outlet />;
};

export default LearningProgramLayout;